import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getSetupStatus(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.QUICKBOOKS.SETUP_STATUS, action.payload, true);
}

export function* saveSetup(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.QUICKBOOKS.SAVE_SETUP, action.payload, true);
}

export function* connect(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.QUICKBOOKS.CONNECT, action.payload, true);
}

export function* disconnect(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.QUICKBOOKS.DISCONNECT, action.payload, true);
}

export function* deleteSetup(action: any): any {
    yield call(sagaFunction, action, CallApi.DELETE, APIS.QUICKBOOKS.DELETE_SETUP, action.payload, true);
}

export function* getManualSyncStatus(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.QUICKBOOKS.MANUAL_SYNC_STATUS, action.payload, true);
}

export function* triggerManualSync(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.QUICKBOOKS.MANUAL_SYNC_TRIGGER, action.payload, true);
}

export function* getManualSyncLog(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.QUICKBOOKS.MANUAL_SYNC_LOG, action.payload, true);
}

export function* retryManualSync(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.QUICKBOOKS.MANUAL_SYNC_RETRY, action.payload, true);
}

export function* getOutboxStatus(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.QUICKBOOKS.OUTBOX_STATUS, action.payload, true);
}

export function* getOutboxLog(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.QUICKBOOKS.OUTBOX_LOG, action.payload, true);
}

export function* retryOutbox(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.QUICKBOOKS.OUTBOX_RETRY + action.payload.outboxId, null, true);
}

export function* retryAllOutbox(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.QUICKBOOKS.OUTBOX_RETRY_ALL, action.payload, true);
}
